/**
 * Created by Vladislav on 18.09.2024.
 */

cleverapps.InitByFeature["map2d"] = function () {
    UnitsLibrary.Init();
};